import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          <div className="footer-section">
            <h3>Math Explorer</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/multiplication">Multiplication Tables</Link></li>
              <li><Link to="/length-units">Length Units Game</Link></li>
              <li><Link to="/math-operations">Math Operations</Link></li>
              <li><Link to="/basic-operations">Basic Operations</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>About</h3>
            <ul>
              <li><Link to="/about">About Us</Link></li>
              <li><a href="https://www.elevateappstudio.com" target="_blank" rel="noopener noreferrer">Elevate App Studio</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-copyright">
          <p>© {currentYear} <a href="https://www.elevateappstudio.com" target="_blank" rel="noopener noreferrer">Elevate App Studio</a>. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 